import { Col, Image, Row } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography, Button, ResponsiveContainer } from '@sunday/component';
import Layout from '../../components/Layout';
import { config } from '../../config';
import useQuery from '../../hooks/useQuery';
import style from './partner.module.scss';
import cn from 'classnames';
import MarketingTypography from 'components/MarketingTypography/MarketingTypography';
import offerData from './offer.json';
import insurerData from './insurer.json';
import highlightData from './highlight.json';

const { ASSET_PREFIX } = config;
export const PartnerPageNameSpace = ['page.partner'];

const Partner = () => {
  const { t } = useTranslation(PartnerPageNameSpace);
  
  return (
    <Layout>
      <Row align='middle' gutter={24} className={style.heroBanner}>
        <Col xs={0} lg={24} style={{ height: '58px' }} />
        <Col xs={24} lg={0} style={{ height: '40px' }} />
        <Col xs={{ span: 20, offset: 2 }} sm={{ span: 10, offset: 4 }} lg={0} >
          <MarketingTypography.Display designLevel={3} weight='bold' className={style.white}>
            {t('tag-1')}<span className={cn(style.highlight)}>{t('tag-2')}</span>
          </MarketingTypography.Display>
          <MarketingTypography.Title designLevel={2} className={style.white}>
            {t('headline-1')}
          </MarketingTypography.Title>
          <a href="/contact">
            <Button fullWidth size='m' style={{ marginTop: "48px", marginBottom: "48px" }}>
              {t('cta')}
            </Button>
          </a>
        </Col>
        <Col xs={0} sm={0} lg={{ span: 10, offset: 4 }} >
          <MarketingTypography.Display designLevel={2} weight='bold' className={style.white}>
            {t('tag-1')}<span className={cn(style.highlight)}>{t('tag-2')}</span>
          </MarketingTypography.Display>
          <MarketingTypography.Title designLevel={1} className={style.white} >
            {t('headline-1')}
          </MarketingTypography.Title>
          <a href="/contact">
            <Button fullWidth size='m' style={{ width: '50%', marginTop: "48px" }}>
              {t('cta')}
            </Button>
          </a>
        </Col>
        <Col xs={24} sm={{ span: 6 }} lg={{ span: 6, offset: 1 }} style={{ textAlign: 'center' }}>
          <Image
            src={`${ASSET_PREFIX}/static/img/img-partner-banner.svg`}
            preview={false}
            alt="hero-banner"
          />
        </Col>
        <Col xs={0} lg={24} style={{ height: '58px' }} />
        <Col xs={24} lg={0} style={{ height: '40px' }} />
      </Row>
      <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
        <ResponsiveContainer className={style.container}>
          <Row align={"middle"} justify={"center"} style={{display: 'flex', flexDirection: 'column'}}>
            <Col xs={0} xl={24}>
              <Typography.Display designLevel={3} weight='bold'>
                {t('partners.title')}
              </Typography.Display>
            </Col>
            <Col xs={24} xl={0}>
              <Typography.Headline designLevel={1} weight='bold'>
                {t('partners.title')}
              </Typography.Headline>
            </Col>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '32px', flexWrap: 'wrap' }}>
              <div className={style.partner}>
                <div style={{ alignSelf: 'center', height: '115px', padding: "20px" }}>
                  <img
                    src={`${ASSET_PREFIX}/static/img/img-pos-indonesia.png`}
                    alt="pos"
                    style={{ height: '100%', width: 'auto'}}
                  />
                </div>
                <Typography.Headline designLevel={2} weight='bold'>
                  {t('partners.pos.title')}
                </Typography.Headline>
                <Typography.Body designLevel={2}>
                  {t('partners.pos.body')}
                </Typography.Body>
              </div>
              <div className={style.partner}>
                <div style={{ alignSelf: 'center' }}>
                  <Image
                    src={`${ASSET_PREFIX}/static/img/img-pegadaian.png`}
                    preview={false}
                    alt="pegadaian"
                    style={{ height: '155px', width: 'auto'}}
                  />
                </div>
                <Typography.Headline designLevel={2} weight='bold'>
                  {t('partners.pegadaian.title')}
                </Typography.Headline>
                <Typography.Body designLevel={2}>
                  {t('partners.pegadaian.body')}
                </Typography.Body>
              </div>
            </div>
          </Row>
        </ResponsiveContainer>
      </div>
      <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
        <ResponsiveContainer className={style.highlightContainer}>
          <Row justify="center" align={"middle"}>
            <Col xl={24} xs={0} style={{ marginBottom: "80px" }}>
              <Typography.Display designLevel={3} weight='bold' >
                {t('highlights.title')}
              </Typography.Display>
              <Typography.Title designLevel={3} >
                {t('highlights.body')}
              </Typography.Title>
            </Col>
            <Col xl={0} xs={24}>
              <Typography.Headline designLevel={1} weight='bold' >
                {t('highlights.title')}
              </Typography.Headline>
              <Typography.Title designLevel={3} >
                {t('highlights.body')}
              </Typography.Title>
            </Col>
          </Row>
          <Row justify={"center"} gutter={48}>
            {highlightData.map((item: any, index: number) => (
              <Col key={`highlight-${index+1}`} style={{width: "360px"}}>
                <Image
                  preview={false}
                  alt={item.altImg}
                  src={`${ASSET_PREFIX}/static/img/${item.fileName}`}
                  style={{ marginBottom: "40px" }}
                />
                <Typography.Headline designLevel={2} weight='bold' style={{ marginTop: 0 }}>
                  {t(`highlights.item-${index+1}.title`)}
                </Typography.Headline>
                <Typography.Body designLevel={2} >
                {t(`highlights.item-${index+1}.body`)}
                </Typography.Body>
              </Col>
            ))}
          </Row>
        </ResponsiveContainer>
      </div>
      <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
        <ResponsiveContainer className={style.productContainer}>
          <Row justify="center">
            <Col xl={12} xs={0}>
              <Typography.Display designLevel={3} weight='bold' className={style.title} >
                {t('offer.title')}
              </Typography.Display>
              <Typography.Title designLevel={3} >
                {t('offer.body')}
              </Typography.Title>
            </Col>
            <Col xl={0} xs={24} style={{marginBottom: '48px'}}>
              <Typography.Headline designLevel={1} weight='bold' className={style.title} >
                {t('offer.title')}
              </Typography.Headline>
              <Typography.Body designLevel={1} >
                {t('offer.body')}
              </Typography.Body>
            </Col>
            <Col xl={12} xs={24} style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
              <Image
                  src={`${ASSET_PREFIX}/static/img/img-offer.svg`}
                  preview={false}
                  alt="offers"
                />
            </Col>
          </Row>
        </ResponsiveContainer>
      </div>

      <Row align="middle" gutter={24} className={style.talkToUs} >
        
          <Col xs={24} lg={12}>
            <Image
              src={`${ASSET_PREFIX}/static/img/img-partner-contact.svg`}
              preview={false}
              alt="talk-to-us"
            />
          </Col>
          <Col xs={0} lg={12}>
            <ResponsiveContainer style={{ display: 'flex', flexDirection: 'column', padding: "80px" }} className={style.container}>
              <MarketingTypography.Display designLevel={2} weight='bold' >
                <span className={style.highlight}>{t('partner.tag-1')}</span> <span className={style.white} >{t('partner.tag-2')}</span>
              </MarketingTypography.Display>
              <MarketingTypography.Title designLevel={3} className={style.white} >
                {t('partner.headline')}
              </MarketingTypography.Title>
              <div style={{ width: "50%", marginTop: "40px"}}>
                <a href='/contact'>
                  <Button fullWidth size='m'>
                    {t('partner.cta')}
                  </Button>
                </a>
              </div>
            </ResponsiveContainer>
          </Col>
          <Col xs={24} lg={0}>
            <ResponsiveContainer style={{ display: 'flex', flexDirection: 'column', padding: "32px 0" }} className={style.container}>
              <MarketingTypography.Display designLevel={3} weight='bold' >
              <span className={style.highlight}>{t('partner.tag-1')}</span> <span className={style.white} >{t('partner.tag-2')}</span>
              </MarketingTypography.Display>
              <MarketingTypography.Body designLevel={1} className={style.white} >
                {t('partner.headline')}
              </MarketingTypography.Body>
              <div style={{ marginTop: "40px"}}>
                <a href='/contact'>
                  <Button fullWidth size='m'>
                  {t('partner.cta')}
                  </Button>
                </a>
              </div>
            </ResponsiveContainer>
          </Col>
        
      </Row>

    </Layout>
  );
};

export default Partner;
